import React from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import { PaginationDot } from './images-pagination-dot';
import { layoutDefaults } from '../../utils/layout-defaults';

function Pagination({ dots, index, onChangeIndex }) {
  const classes = useStyles();

  // async function onClick(pIndex) {
  //   onChangeIndex?.call(this, pIndex);
  // }

  return (
    <div className={classes.container}>
      {new Array(dots).fill('').map((dot, i) => (
        <PaginationDot
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          index={i}
          active={i === index}
          onClick={onChangeIndex}
        />
      ))}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    pointerEvents: 'none',
    // width: "100%",
    // bottom: 8,
    // right: 8,
    top: -16 - layoutDefaults.verticalMargin,
    marginBottom: -16,
    // bottom: -30,
    // marginTop: -10,
    // display: "flex",
    // flexGrow: 1,
    // flexDirection: "row",
    // zIndex: 999999,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',

    // border: "1px solid green",
  },
  dots: {},
});

Pagination.propTypes = {
  dots: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  // onChangeIndex: PropTypes.func.isRequired,
};

export { Pagination };
